<template>
    <b-modal 
        ref="logoutConfirmationModal"
        :hide-footer="true"
    >
        <template v-slot:modal-header="{ close }">
            <a href="#">
                <img src="../../assets/images/logo-color.png" alt="Dicicil Aja">
            </a>
            <button @click="hide" type="button" class="close orange" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </template>

        <form role="form" class="p-lr-50">
            <h2 class="color-orange p-t-50 p-b-50 bold font-montserrat">Apakah anda yakin ingin keluar?</h2>
        </form>
        <div class="w-100">
            <button
                class="float-right btn btn-orange semibold m-b-10"
                @click.prevent="logout"
            >
                Ya, saya ingin keluar
            </button>
            <button
                class="float-right btn btn-orange semibold m-b-10 btn-close"
                @click="hide"
            >
                kembali
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'LogoutConfirmationModal',
    props: {
        logout: Function
    },
    methods: {
        show () {
            this.$refs['logoutConfirmationModal'].show()
        },
        hide () {
            this.$refs['logoutConfirmationModal'].hide()
        }
    }
};
</script>

<style scoped>
.btn-close {
    margin-right: 10px;
    background: white!important;
    color: #f6861f!important;
    border: 2px solid #f6861f;
}
.btn-close:hover {
    color: white!important;
}
</style>